import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import BrandLoader from './BrandLoader';

interface PageTransitionProps {
  children: React.ReactNode;
  delay?: number; // Tiempo mínimo que se muestra el loading en ms
}

const PageTransition = ({ children, delay = 100 }: PageTransitionProps) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [displayChildren, setDisplayChildren] = useState(false);

  useEffect(() => {
    // Reset loading cuando cambia la ruta
    setIsLoading(true);
    setDisplayChildren(false);

    // Esperar un tiempo mínimo antes de mostrar el contenido
    const timer = setTimeout(() => {
      setIsLoading(false);
      
      // Pequeña espera adicional para renderizar completamente
      const renderTimer = setTimeout(() => {
        setDisplayChildren(true);
      }, 50);

      return () => clearTimeout(renderTimer);
    }, delay);

    return () => clearTimeout(timer);
  }, [location.pathname, delay]);

  if (isLoading || !displayChildren) {
    return <BrandLoader fullHeight message={null} />;
  }

  return <>{children}</>;
};

export default PageTransition;
